import { render } from "./AdminDocument.vue?vue&type=template&id=506c2e90"
import script from "./AdminDocument.vue?vue&type=script&lang=js"
export * from "./AdminDocument.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__